export default "__VITE_ASSET__JM8AY48y__"